import React, { useState } from 'react';
import { Modal } from '../ui/Modal';
type ModalType = 'none' | 'privacy' | 'terms';
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>('none');
  const closeModal = () => setActiveModal('none');
  return <>
      <footer className="bg-stone-950 py-12 text-center text-sm" data-id="element-35">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col items-center space-y-4" data-id="element-36">
          <p className="text-stone-500" data-id="element-37">
            © {new Date().getFullYear()} El Método Casa Limpia. Todos los
            derechos reservados.
          </p>

          <div className="flex items-center justify-center space-x-6 text-stone-400" data-id="element-38">
            <button onClick={() => setActiveModal('privacy')} className="hover:text-orange-400 transition-colors focus:outline-none focus:underline" data-id="element-39">
              Política de Privacidad
            </button>
            <span className="text-stone-700" aria-hidden="true" data-id="element-40">
              |
            </span>
            <button onClick={() => setActiveModal('terms')} className="hover:text-orange-400 transition-colors focus:outline-none focus:underline" data-id="element-41">
              Términos y Condiciones
            </button>
          </div>
        </div>
      </footer>

      {/* Privacy Policy Modal */}
      <Modal isOpen={activeModal === 'privacy'} onClose={closeModal} title="Política de Privacidad" data-id="element-42">
        <div className="prose prose-stone prose-sm sm:prose-base max-w-none" data-id="element-43">
          <p data-id="element-44">Última actualización: {new Date().toLocaleDateString('es-ES')}</p>

          <h3 className="text-lg font-bold text-stone-900 mt-6 mb-2" data-id="element-45">
            1. Información que recopilamos
          </h3>
          <p data-id="element-46">
            Recopilamos información que usted nos proporciona directamente
            cuando utiliza nuestro sitio web, como su nombre, dirección de
            correo electrónico y cualquier otra información que decida compartir
            al registrarse o interactuar con nuestros servicios.
          </p>

          <h3 className="text-lg font-bold text-stone-900 mt-6 mb-2" data-id="element-47">
            2. Uso de la información
          </h3>
          <p data-id="element-48">
            Utilizamos la información recopilada para proporcionar, mantener y
            mejorar nuestros servicios, así como para comunicarnos con usted,
            responder a sus consultas y enviarle actualizaciones relacionadas
            con "El Método Casa Limpia".
          </p>

          <h3 className="text-lg font-bold text-stone-900 mt-6 mb-2" data-id="element-49">
            3. Cookies y tecnologías similares
          </h3>
          <p data-id="element-50">
            Utilizamos cookies y tecnologías de seguimiento similares para
            rastrear la actividad en nuestro servicio y mantener cierta
            información. Las cookies son archivos con una pequeña cantidad de
            datos que pueden incluir un identificador único anónimo.
          </p>

          <h3 className="text-lg font-bold text-stone-900 mt-6 mb-2" data-id="element-51">
            4. Compartir su información
          </h3>
          <p data-id="element-52">
            No vendemos, comercializamos ni alquilamos su información personal a
            terceros. Podemos compartir información genérica agregada no
            vinculada a ninguna información de identificación personal con
            nuestros socios comerciales y anunciantes de confianza.
          </p>

          <h3 className="text-lg font-bold text-stone-900 mt-6 mb-2" data-id="element-53">
            5. Seguridad de los datos
          </h3>
          <p data-id="element-54">
            La seguridad de sus datos es importante para nosotros, pero recuerde
            que ningún método de transmisión a través de Internet o método de
            almacenamiento electrónico es 100% seguro. Aunque nos esforzamos por
            utilizar medios comercialmente aceptables para proteger su
            información personal, no podemos garantizar su seguridad absoluta.
          </p>

          <h3 className="text-lg font-bold text-stone-900 mt-6 mb-2" data-id="element-55">
            6. Sus derechos
          </h3>
          <p data-id="element-56">
            Usted tiene derecho a acceder, actualizar o eliminar la información
            que tenemos sobre usted. Si desea ejercer estos derechos, por favor
            contáctenos a través de los canales oficiales proporcionados en
            nuestra plataforma.
          </p>
        </div>
      </Modal>

      {/* Terms and Conditions Modal */}
      <Modal isOpen={activeModal === 'terms'} onClose={closeModal} title="Términos y Condiciones" data-id="element-57">
        <div className="prose prose-stone prose-sm sm:prose-base max-w-none" data-id="element-58">
          <p data-id="element-59">Última actualización: {new Date().toLocaleDateString('es-ES')}</p>

          <h3 className="text-lg font-bold text-stone-900 mt-6 mb-2" data-id="element-60">
            1. Aceptación de los términos
          </h3>
          <p data-id="element-61">
            Al acceder y utilizar este sitio web y los servicios de "El Método
            Casa Limpia", usted acepta estar sujeto a estos Términos y
            Condiciones. Si no está de acuerdo con alguna parte de estos
            términos, no podrá acceder al servicio.
          </p>

          <h3 className="text-lg font-bold text-stone-900 mt-6 mb-2" data-id="element-62">
            2. Uso del servicio
          </h3>
          <p data-id="element-63">
            El contenido proporcionado en este sitio web es únicamente para su
            información general y uso personal. Está sujeto a cambios sin previo
            aviso. Ni nosotros ni ningún tercero ofrecemos ninguna garantía en
            cuanto a la exactitud, puntualidad, rendimiento, integridad o
            idoneidad de la información y los materiales encontrados u ofrecidos
            en este sitio web.
          </p>

          <h3 className="text-lg font-bold text-stone-900 mt-6 mb-2" data-id="element-64">
            3. Propiedad intelectual
          </h3>
          <p data-id="element-65">
            El servicio y su contenido original, características y funcionalidad
            son y seguirán siendo propiedad exclusiva de "El Método Casa Limpia"
            y sus licenciantes. El servicio está protegido por derechos de
            autor, marcas registradas y otras leyes.
          </p>

          <h3 className="text-lg font-bold text-stone-900 mt-6 mb-2" data-id="element-66">
            4. Compras y pagos
          </h3>
          <p data-id="element-67">
            Si desea comprar cualquier producto o servicio disponible a través
            del sitio, se le puede pedir que proporcione cierta información
            relevante para su compra, incluyendo, sin limitación, su número de
            tarjeta de crédito, la fecha de vencimiento de su tarjeta de crédito
            y su dirección de facturación.
          </p>

          <h3 className="text-lg font-bold text-stone-900 mt-6 mb-2" data-id="element-68">
            5. Limitación de responsabilidad
          </h3>
          <p data-id="element-69">
            En ningún caso "El Método Casa Limpia", ni sus directores,
            empleados, socios, agentes, proveedores o afiliados, serán
            responsables de ningún daño indirecto, incidental, especial,
            consecuente o punitivo, incluyendo sin limitación, pérdida de
            beneficios, datos, uso, fondo de comercio u otras pérdidas
            intangibles, resultantes de su acceso o uso o incapacidad de acceder
            o utilizar el servicio.
          </p>

          <h3 className="text-lg font-bold text-stone-900 mt-6 mb-2" data-id="element-70">
            6. Modificaciones
          </h3>
          <p data-id="element-71">
            Nos reservamos el derecho, a nuestra sola discreción, de modificar o
            reemplazar estos Términos en cualquier momento. Lo que constituye un
            cambio material será determinado a nuestra sola discreción.
          </p>
        </div>
      </Modal>
    </>;
}